import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Icon from '../../components/icons';
import { Stat } from '../../components/stats/Stat';
import { StatListItem } from '../../components/stats/StatListItem';

export const WarehouseDashboardToday: React.FC = () => {
  const { t } = useTranslation('app');

  // Mock data - would come from props or API in real implementation
  const todayMetrics = {
    ordersProcessed: 125,
    ordersPending: 43,
    pickRate: 78.4,
    taskCompletion: 86,
    activeWorkers: 12,
    topPerformer: 'John Smith',
    topPerformerPicks: 246,
    totalPicksToday: 1489,
    averagePickTime: 1.8,
    productivity: 92,
  };

  return (
    <div className="p-4">
      <h2 className="mb-4 text-2xl font-bold">{t('Today')}</h2>
      
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Stat
          hasHelper
          isPreview
          title={t('Order Status')}
          value={todayMetrics.ordersProcessed}
          icon={Icon.Package}
        >
          <StatListItem
            title={t('Orders Processed')}
            value={todayMetrics.ordersProcessed}
          />
          <StatListItem
            title={t('Orders Pending')}
            value={todayMetrics.ordersPending}
          />
          <StatListItem
            title={t('Task Completion')}
            value={todayMetrics.taskCompletion}
            unitOfMeasure="%"
          />
        </Stat>

        <Stat
          hasHelper
          isPreview
          title={t('Productivity')}
          value={todayMetrics.productivity}
          unitOfMeasure="%"
          icon={Icon.ChartLineUp}
        >
          <StatListItem
            title={t('Pick Rate')}
            value={todayMetrics.pickRate}
            unitOfMeasure="/hr"
          />
          <StatListItem
            title={t('Average Pick Time')}
            value={todayMetrics.averagePickTime}
            unitOfMeasure="min"
          />
          <StatListItem
            title={t('Total Picks Today')}
            value={todayMetrics.totalPicksToday}
          />
        </Stat>

        <Stat
          hasHelper
          isPreview
          title={t('Workforce')}
          value={todayMetrics.activeWorkers}
          icon={Icon.Users}
        >
          <StatListItem
            title={t('Active Workers')}
            value={todayMetrics.activeWorkers}
          />
          <StatListItem
            title={t('Top Performer')}
            value={todayMetrics.topPerformerPicks}
            label={todayMetrics.topPerformer}
          />
        </Stat>
      </div>
    </div>
  );
};

export default WarehouseDashboardToday;
